import { View, Text, Dimensions, Image } from "react-native";
import React from "react";
import { femaleColor, maleColor, primary, white } from "../../colors";
import { tests, tutorial } from "../../imports";
import translate from "../../functions/translate";
import MyText from "../../components/custom/MyText";
import { useDispatch, useSelector } from "react-redux";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import {
  changeHeaderColor,
  showBackButtonWithFunction,
} from "../../redux/header/headerAction";
import { useEffect } from "react";
import { useState } from "react";
import SelectChildrenMini from "../../components/custom/SelectChildrenMini";
import TestItem from "../../components/test/TestItem";
import TestDetailsHeader from "../../components/test/TestDetailsHeader";
import TestSectionDetails from "../../components/test/TestSectionDetails";
import { ScrollView } from "react-native-gesture-handler";

export default function TestDetails({ route }) {
  const { id, type, childName, childId, childGender, childImage } =
    route.params;
  const getTypeName = () => {};
  const dispatch = useDispatch();
  const main = useSelector((store) => store.main);
  const navigation = useNavigation();

  const [changed, setChanged] = useState(false);
  const isFocused = useIsFocused();
  useEffect(() => {
    if (isFocused) {
      setChanged(!changed);
      dispatch(changeHeaderColor("#EBD7FF"));
      dispatch(showBackButtonWithFunction(() => navigation.goBack()));
    }
  }, [isFocused]);

  return (
    <ScrollView>
      <View
        style={{
          width: "100%",
          alignItems: "center",
          flex: 1,
          paddingBottom: 100,
        }}
      >
        <View style={{ alignItems: "center", width: "100%" }}>
          <View
            style={{
              height: Dimensions.get("window").height,
              marginTop: -1 * Dimensions.get("window").height,
              backgroundColor: "#EBD7FF",
              width: "100%",
            }}
          ></View>
          <View style={{ alignItems: "center" }}>
            <View style={{ backgroundColor: "#EBD7FF" }}>
              <View
                style={{
                  backgroundColor: "#EBD7FF",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 10,
                  width: Dimensions.get("screen").width,
                  minHeight: 100,
                  flexDirection: "row",
                  paddingHorizontal: 10,
                }}
              >
                <View style={{ flex: 5 }}>
                  <View>
                    <MyText
                      style={{
                        fontSize: 30,
                        marginTop: 10,
                        marginHorizontal: 10,
                        color: "#504E4E",
                      }}
                    >
                      {translate("tests and history")}
                    </MyText>
                  </View>
                  <View
                    direction={main.rtl ? "rtl" : "ltr"}
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      marginTop: 10,
                    }}
                  ></View>
                </View>
                <View style={{ flex: 2 }}>
                  <Image
                    source={tests}
                    style={{ width: "100%", height: 90 }}
                    resizeMode="contain"
                  />
                </View>
              </View>
            </View>
          </View>
        </View>
        <TestDetailsHeader
          childName={childName}
          childGender={childGender}
          childId={childId}
          type={type}
          changed={changed}
          childImage={childImage}
        />
        <TestSectionDetails
          id={id}
          type={type}
          childId={childId}
          changed={changed}
        />
      </View>
    </ScrollView>
  );
}
